import styled from 'styled-components';
import React from 'react';

export default styled((props) => (
  <div {...props}>
    <div className='label'>FOCUS</div> <div className='line'></div>
  </div>
))`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin: 10px 0 20px;
  & > .line {
    height: 1px;
    background: rgba(40, 56, 144, 0.1);
    width: 100%;
    margin-left: 4px;
  }
  & .label {
    color: #677b8b;
    font-size: 10px;
    font-weight: 700;
    width: fit-content;
    text-wrap: nowrap;
  }
`;
